module.exports = __webpack_public_path__ + "9-o1.jpg?66ed9a6cd75c1182f18d17da9f9236bc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/9-o1.jpg
// module id = 664
// module chunks = 0